/**
 * @generated SignedSource<<f6df72d73b7e95b7e48ea46ada64a43c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionCard_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cardFieldsList_updateWorkItemAllFieldTypesActionRenderer" | "cardHeader_updateWorkItemAllFieldTypesActionRenderer">;
  readonly " $fragmentType": "actionCard_updateWorkItemAllFieldTypesActionRenderer";
};
export type actionCard_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: actionCard_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionCard_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldIdsOrAliases"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sprintAris"
    }
  ],
  "kind": "Fragment",
  "name": "actionCard_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "cardHeader_updateWorkItemAllFieldTypesActionRenderer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fieldIdsOrAliases",
          "variableName": "fieldIdsOrAliases"
        },
        {
          "kind": "Variable",
          "name": "sprintAris",
          "variableName": "sprintAris"
        }
      ],
      "kind": "FragmentSpread",
      "name": "cardFieldsList_updateWorkItemAllFieldTypesActionRenderer"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "98ae4d49e9b05c3494c1be19e282f771";

export default node;
